import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import { IconButton, Stack } from '@mui/material'
import useValidationNavList from '@/hooks/useValidationNavList'
import { altHotKeyStr } from '@/utils/os'
import PageCount from '@/components/image-zoom-pan/PageCount'
import KeyboardShortcutsTooltip from '@/components/keyboard-shortcuts-tooltip/KeyboardShortcutsTooltip'

type DocumentNavigationButtonsProps = {
  documentsCount?: number
} & Omit<ReturnType<typeof useValidationNavList>, 'nextDocumentId'>

export default function DocumentNavigationButtons({
  hasPreviousDocument,
  hasNextDocument,
  selectedIndex,
  goToPreviousDocument,
  goToNextAvailableDocumentOrClose,
  documentsCount,
}: DocumentNavigationButtonsProps) {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <KeyboardShortcutsTooltip
        title="Previous Document"
        keyboardShortcuts={[`${altHotKeyStr} + 1`]}
        arrow
        enterDelay={1000}
      >
        <IconButton
          size="small"
          disabled={!hasPreviousDocument}
          onClick={goToPreviousDocument}
        >
          <KeyboardArrowLeft />
        </IconButton>
      </KeyboardShortcutsTooltip>
      {documentsCount !== undefined && (
        <PageCount page={selectedIndex + 1} total={documentsCount} />
      )}
      <KeyboardShortcutsTooltip
        title="Next Document"
        keyboardShortcuts={[`${altHotKeyStr} + 2`]}
        arrow
        enterDelay={1000}
      >
        <IconButton
          size="small"
          disabled={!hasNextDocument}
          onClick={goToNextAvailableDocumentOrClose}
        >
          <KeyboardArrowRight />
        </IconButton>
      </KeyboardShortcutsTooltip>
    </Stack>
  )
}
